(function () {
  var BREAKPOINT = 1024;
  var lastIsMobile = window.innerWidth <= BREAKPOINT;

  function lightboxEl() {
    return document.getElementById('instafeed-lightbox') || document.querySelector('.instafeed-lightbox');
  }

  function isOpen(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function unlockPage() {
    document.body.classList.remove('instafeed-body-no-scroll');
    document.documentElement.classList.remove('instafeed-body-no-scroll');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow-y');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow-y');
  }

  function restoreCloseButton(el) {
    var closeBtn = el.querySelector('.instafeed-close-button');
    var bar = el.querySelector('.instafeed-bottom-bar');
    if (!closeBtn || !bar || bar.contains(closeBtn)) return;
    if (bar.firstChild) bar.insertBefore(closeBtn, bar.firstChild);
    else bar.appendChild(closeBtn);
  }

  function forceClose(el) {
    if (!el) {
      unlockPage();
      return;
    }
    restoreCloseButton(el);
    var closeBtn = el.querySelector('.instafeed-close-button');
    if (closeBtn) {
      try {
        closeBtn.click();
      } catch (e) {}
    }
    el.style.setProperty('display', 'none', 'important');
    el.style.opacity = '0';
    unlockPage();
  }

  function onBreakpointChange() {
    var el = lightboxEl();
    if (!el || !isOpen(el)) {
      unlockPage();
      return;
    }
    restoreCloseButton(el);
    forceClose(el);
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    var isMobile = window.innerWidth <= BREAKPOINT;
    if (isMobile === lastIsMobile) return;
    lastIsMobile = isMobile;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onBreakpointChange, 50);
  });
})();
